import React, { Component } from "react";
import { BsFileEarmarkArrowDown, BsPencil } from "react-icons/bs";
import { url_creation } from "../utils/DatabaseHelper";
import CsvExportDialog from "./CsvExportDialog";

// Der CSV-Export-Dialog greift auf dem Übersicht-Report-Pfad und der
// Mitarbeiter-Liste (#mitarbeiter); beide Endpunkte haben Backend-Support für
// fields/metaCols. Die Archiv-Page hat keinen CSV-Button (Archiv-Route
// wird erst bei dessen Einführung ergänzt)
const DIALOG_EXPORT_ENDPOINTS = ["report/mitarbeiter_uebersicht", "mitarbeiter"];

class QuickAction extends Component {
  state = {
    loading: false,
    exportDialog: null,
  };

  handleCsvClick = () => {
    const { apiEndpoint } = this.props.csvQuery || {};
    if (apiEndpoint && DIALOG_EXPORT_ENDPOINTS.includes(apiEndpoint)) {
      this.setState({ exportDialog: this.props.csvQuery });
    } else {
      this.handleCsvDownload();
    }
  };

  handleCsvDownload = async () => {
    this.setState({ loading: true });
    const { apiEndpoint, query } = this.props.csvQuery ?? "";
    if (!apiEndpoint) {
      // csvQuery noch nicht gesetzt (Tabelle lädt) — Download still abbrechen
      this.setState({ loading: false });
      return;
    }
    try {
      const { url, headers } = url_creation(apiEndpoint, "", query);
      const fullUrl = url + "&limit=ALL&format=csv";

      const res = await fetch(fullUrl, headers);
      if (!res.ok) throw new Error(`Fehler ${res.status}`);

      const blob = await res.blob();
      const cd = res.headers.get("content-disposition") || "";
      const fileNameMatch = cd.match(/filename="?([^"]+)"?/);
      const fileName = fileNameMatch ? fileNameMatch[1] : "daten.csv";

      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("CSV-Download-Fehler:", err);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const isCsv = this.props.title === "CSV";
    const isSettings = this.props.title === "widget-settings";
    const iconPlus = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_129_38)">
          <path
            d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
            fill="white"
          />
          <path
            d="M8 4C8.13261 4 8.25979 4.05268 8.35355 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V7.5H11.5C11.6326 7.5 11.7598 7.55268 11.8536 7.64645C11.9473 7.74021 12 7.86739 12 8C12 8.13261 11.9473 8.25979 11.8536 8.35355C11.7598 8.44732 11.6326 8.5 11.5 8.5H8.5V11.5C8.5 11.6326 8.44732 11.7598 8.35355 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74021 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H7.5V4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74021 4.05268 7.86739 4 8 4Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_129_38">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );

    if (isCsv) {
      return (
        <div className="col-auto p-2">
          <button className="btn btn-csv" onClick={this.handleCsvClick}>
            <BsFileEarmarkArrowDown
              style={{ color: "#f47a37", fontSize: "16px" }}
            />
            {this.state.loading ? "Lade csv..." : "CSV"}
          </button>
          {this.state.exportDialog && (
            <CsvExportDialog
              isOpen={true}
              apiEndpoint={this.state.exportDialog.apiEndpoint}
              tabellenQuery={this.state.exportDialog.query}
              onClose={() => this.setState({ exportDialog: null })}
            />
          )}
        </div>
      );
    }

    if (isSettings) {
      return (
        <div className="col-auto p-2">
          <BsPencil
            style={{ fontSize: "18px", color: "grey", cursor: "pointer" }}
            onClick={() => this.props.action()}
            title="Widget-Einstellungen"
          />
        </div>
      );
    }
    if (this.props.simpleLink) {
      return (
        <div className="col-auto p-2">
          <button
            className="btn btn-primary"
            onClick={() => this.props.action()}
          >
            {this.props.title}
          </button>
        </div>
      );
    }

    return (
      <div className="col-auto p-2">
        <button
          className="btn btn-primary"
          onClick={() => this.props.action()}
          disabled={this.props.disabled}
        >
          {iconPlus}
          {this.props.title}
        </button>
      </div>
    );
  }
}

export default QuickAction;
